import React, { useEffect, useState } from "react";

//UI Material
import {
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

//Local components
import StockoutRow from "./StockoutRow";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Material Icons
import { ArrowBack } from "@mui/icons-material";

export default function StockoutsTable({ method = "all" }) {
  // ==========>Component States<==========
  //State for stockouts list
  const [stockoutsList, setStockoutsList] = useState([]);
  //Stockouts loader
  const [stockoutsLoader, setStockoutsLoader] = useState(true);
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for setting error when could not get products data
  const [dataError, setDataError] = useState(false);

  // ==========>Component UseEffects<==========
  useEffect(() => {
    getStockoutsList();
  }, []);

  // ==========>Component Functions<==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function to select the method for data query
  const selectPathAccordingToReceivedMethod = () => {
    switch (method) {
      case "all":
        return `/inventory/get-stockouts`;
      case "item":
        return `/inventory/get-stockouts-by-item`;
      default:
        return `/inventory/get-stockouts`;
    }
  };

  //Function to get items list
  const getStockoutsList = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        selectPathAccordingToReceivedMethod(),
        {
          howMany: 2500,
          id: new URLSearchParams(window.location.search).get("id")
        }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setStockoutsList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(false);
    }
    setStockoutsLoader(false);
  };

  // ==========>Component<==========
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={1}
        sx={{ p: 2 }}
      >
        <ArrowBack color="error" />
        <Typography variant="h6" fontWeight="bold">
          {stockoutsList.length}
        </Typography>
        <Typography variant="h7">
          {`salidas de ítems registradas en inventario`}
        </Typography>
      </Stack>
      <TableContainer>
        <Table aria-label="items-table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  ID
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Código
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Ítem
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Fecha de salida
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Cantidad
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Razón
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                  Acciones
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stockoutsLoader ? (
              <TableCell align="center" colSpan={7}>
                <CircularProgress />
              </TableCell>
            ) : (
              stockoutsList
                .slice()
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .map((stockout) => (
                  <StockoutRow key={stockout.id} stockoutData={stockout} />
                ))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={stockoutsList.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        labelRowsPerPage="Filas"
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
